import type { CourseModule } from "../content/types";
import type { ActivityState } from "./progress";

export function isActivityReady(
  module: CourseModule,
  state?: ActivityState,
): boolean {
  const ready = (activity: NonNullable<CourseModule["activity"]>, activityState?: ActivityState) => {
    if (!activityState) return false;
    if (activity.kind === "quiz") {
    const answers = activityState.answers as Record<string, number> | undefined;
    return Boolean(
      answers &&
        activity.questions.every((question) => question.id in answers),
    );
  }
  if (activity.kind === "order") {
    return activityState.correct === true;
  }
  const values = activityState.values as Record<string, string> | undefined;
  if (!values) return false;
  const completed = activity.fields.filter(
    (field) => (values[field.id] ?? "").trim().length >= 12,
  ).length;
    return completed >= activity.minimumCompletedFields;
  };
  const primaryReady = module.activity ? ready(module.activity, (state?.primary as ActivityState | undefined) ?? state) : true;
  const knowledgeReady = module.knowledgeCheck ? ready(module.knowledgeCheck, state?.knowledge as ActivityState | undefined) : true;
  return primaryReady && knowledgeReady;
}
